import { type RefreshTokenActionOptions, refreshTokenAction } from '../actions/refresh-token-action';

export type RefreshTokenResult = { success: true; token: string } | { success: false; error: string };

const TIMEOUT_MS = process.env.NODE_ENV === 'development' ? 1_500 : 8_000;

export async function refreshTokenWithTimeout(options?: RefreshTokenActionOptions): Promise<RefreshTokenResult> {
    // On the server the action runs in-process, with no Flight stream to stall on.
    if (typeof window === 'undefined') {
        return await refreshTokenAction(options);
    }

    let timer: ReturnType<typeof setTimeout> | undefined;

    try {
        return await Promise.race([
            refreshTokenAction(options),
            new Promise<RefreshTokenResult>(resolve => {
                timer = setTimeout(
                    () => resolve({ success: false, error: 'Session token exchange timed out' }),
                    TIMEOUT_MS,
                );
            }),
        ]);
    } finally {
        if (timer !== undefined) clearTimeout(timer);
    }
}
